<template>
  <v-card>
    <popup-form v-on:close="close" v-on:submit="submit" :newObj="newObj" :remove="remove">
      <template slot>
        <v-container class="px-2 py-4">
          <v-textarea
            v-model="text.value"
            :label="text.label"
            filled
            auto-grow
            rows="1"
            hide-details
          ></v-textarea>
        </v-container>
      </template>
    </popup-form>
  </v-card>
</template>

<script>
export default {
  props: {
    newObj: Boolean,
    text: Object
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    create() {
      this.$emit("create");
    },
    update() {
      this.$emit("update");
    },
    remove() {
      this.$emit("remove");
    },
    submit() {
      if (this.text.value) {
        this.newObj ? this.create() : this.update();
      }
    }
  }
};
</script>